(function () {
  var videoSelector = '[data-product-gallery-video]';
  var initializedAttribute = 'data-product-gallery-video-initialized';
  var activeClass = 'product-gallery-video--playing';
  var controlsVisibleClass = 'product-gallery-video--controls-visible';

  function isAutoplayEnabled(container) {
    return container.dataset.autoplay === 'true';
  }

  function isPriority(container) {
    return container.dataset.priority === 'true';
  }

  function getPlayer(container) {
    return container.querySelector('[data-product-gallery-video-player]');
  }

  function isHosted(container) {
    return container.dataset.productGalleryVideoType === 'hosted';
  }

  function loadMedia(container) {
    if (container.dataset.loaded === 'true') return false;

    var player = getPlayer(container);
    if (!player) return false;

    if (isHosted(container)) {
      player.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      player.load();
    } else if (player.dataset.src) {
      player.src = player.dataset.src;
      player.removeAttribute('data-src');
    }

    container.dataset.loaded = 'true';
    return true;
  }

  function pauseSiblingVideos(container) {
    var product = container.closest('.product');
    var scope = product || document;

    scope.querySelectorAll(videoSelector).forEach(function (otherContainer) {
      if (otherContainer !== container) {
        pauseMedia(otherContainer);
      }
    });
  }

  function postExternalCommand(player, provider, command) {
    if (!player || !player.contentWindow) return;

    if (provider === 'vimeo') {
      var vimeoMethod = command === 'playVideo' ? 'play' : command === 'pauseVideo' ? 'pause' : 'setMuted';
      player.contentWindow.postMessage(
        JSON.stringify({
          method: vimeoMethod,
          value: command === 'mute' ? true : undefined
        }),
        '*'
      );
      return;
    }

    player.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: command,
        args: []
      }),
      '*'
    );
  }

  function getExternalProvider(player) {
    var src = player ? player.src || player.dataset.src || '' : '';
    return src.indexOf('vimeo') !== -1 ? 'vimeo' : 'youtube';
  }

  function playMedia(container) {
    var player = getPlayer(container);
    if (!player) return;

    var loadedNow = loadMedia(container);
    pauseSiblingVideos(container);

    if (isHosted(container)) {
      player.muted = true;
      player.controls = false;
      player.playsInline = true;

      var playPromise = player.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {});
      }
    } else {
      var provider = getExternalProvider(player);
      var playExternal = function () {
        postExternalCommand(player, provider, 'mute');
        postExternalCommand(player, provider, 'playVideo');
      };

      if (loadedNow) {
        player.addEventListener('load', playExternal, { once: true });
      } else {
        playExternal();
      }
    }

    container.classList.add(activeClass);
    showControlsTemporarily(container);
  }

  function clearControlsTimer(container) {
    if (container.productGalleryVideoControlsTimer) {
      window.clearTimeout(container.productGalleryVideoControlsTimer);
      container.productGalleryVideoControlsTimer = null;
    }
  }

  function showControlsTemporarily(container) {
    clearControlsTimer(container);
    container.classList.add(controlsVisibleClass);

    if (!container.classList.contains(activeClass)) return;

    container.productGalleryVideoControlsTimer = window.setTimeout(function () {
      container.classList.remove(controlsVisibleClass);
      container.productGalleryVideoControlsTimer = null;
    }, 1200);
  }

  function toggleMedia(container) {
    var player = getPlayer(container);
    if (!player) return;

    if (isHosted(container)) {
      if (player.paused) {
        playMedia(container);
      } else {
        pauseMedia(container);
      }
      return;
    }

    if (container.classList.contains(activeClass)) {
      pauseMedia(container);
    } else {
      playMedia(container);
    }
  }

  function pauseMedia(container) {
    var player = getPlayer(container);
    if (!player) return;

    if (isHosted(container)) {
      player.pause();
    } else {
      postExternalCommand(player, getExternalProvider(player), 'pauseVideo');
    }

    container.classList.remove(activeClass);
    clearControlsTimer(container);
    container.classList.remove(controlsVisibleClass);
  }

  function isRenderable(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function isMobileGallery(container) {
    return !!container.closest('.product__media-container.below-mobile');
  }

  function isActiveMobileSlide(container) {
    var slide = container.closest('.swiper-slide');
    return !slide || slide.classList.contains('swiper-slide-active');
  }

  function updateAutoplayState(container) {
    if (!isAutoplayEnabled(container) || !isRenderable(container)) return;

    if (isMobileGallery(container) && !isActiveMobileSlide(container)) {
      pauseMedia(container);
      return;
    }

    var rect = container.getBoundingClientRect();
    var visible = rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;

    if (visible) {
      playMedia(container);
    } else {
      pauseMedia(container);
    }
  }

  function initVideo(container) {
    if (container.hasAttribute(initializedAttribute)) return;
    container.setAttribute(initializedAttribute, 'true');

    var player = getPlayer(container);
    if (!player) return;

    if (isHosted(container)) {
      player.muted = true;
      player.controls = false;
      player.playsInline = true;
      player.addEventListener('play', function () {
        player.muted = true;
        player.controls = false;
        container.classList.add(activeClass);
        showControlsTemporarily(container);
      });
      player.addEventListener('pause', function () {
        container.classList.remove(activeClass);
        clearControlsTimer(container);
        container.classList.remove(controlsVisibleClass);
      });
      player.addEventListener('ended', function () {
        player.currentTime = 0;
        var playPromise = player.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {});
        }
      });
    }

    if (isPriority(container)) {
      loadMedia(container);
    }

    var playButton = container.querySelector('[data-product-gallery-video-play]');
    if (playButton) {
      playButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleMedia(container);
        container.classList.add('product-gallery-video--user-played');
      });
    }

    container.addEventListener('click', function () {
      if (container.classList.contains(activeClass)) {
        showControlsTemporarily(container);
      }
    });

    updateAutoplayState(container);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(videoSelector).forEach(initVideo);
    updateAll();
  }

  function updateAll() {
    document.querySelectorAll(videoSelector).forEach(updateAutoplayState);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          updateAutoplayState(entry.target);
        });
      },
      {
        threshold: [0, 0.35, 0.65]
      }
    );

    var observeInitialized = function () {
      document.querySelectorAll(videoSelector).forEach(function (container) {
        observer.observe(container);
      });
    };

    document.addEventListener('DOMContentLoaded', observeInitialized);
    document.addEventListener('shopify:section:load', observeInitialized);
  }

  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'class';
      });

      if (shouldUpdate) {
        window.requestAnimationFrame(updateAll);
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      mutationObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    window.addEventListener('resize', updateAll, { passive: true });
    window.addEventListener('scroll', updateAll, { passive: true });
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
